import { inputRules, wrappingInputRule, InputRule } from 'prosemirror-inputrules'
import { NodeType, Schema } from 'prosemirror-model'
import { TextSelection } from 'prosemirror-state'

/*
  Copied from prosemirror example docs.
  @see https://github.com/ProseMirror/prosemirror-example-setup/blob/master/src/inputrules.ts
 */

/// Given a list node type, returns an input rule that turns a number
/// followed by a dot at the start of a textblock into an ordered list.
const orderedListRule = (nodeType: NodeType) => {
  return wrappingInputRule(
    /^(\d+)\.\s$/,
    nodeType,
    (match) => ({ order: +match[1] }),
    (match, node) => node.childCount + node.attrs.order === +match[1],
  )
}

/// Given a list node type, returns an input rule that turns a bullet
/// (dash, plush, or asterisk) at the start of a textblock into a
/// bullet list.
const bulletListRule = (nodeType: NodeType) => {
  return wrappingInputRule(/^\s*([-+*])\s$/, nodeType)
}

const codeMarkRule = () => {
  const regex = /(^|[\s*_:=~])`((?=\S).*?(?=\S).)`$/
  return new InputRule(regex, (state, match, start, end) => {
    const mark = state.schema.marks.code.create()
    const tr = state.tr
    const match1Offset = match[0].indexOf(match[1])
    const match2Offset = match[0].indexOf(match[2], match1Offset + 1)
    tr.addMark(start + match2Offset, start + match2Offset + match[2].length, mark)
    const prefixLength = match2Offset - (match1Offset + match[1].length)
    if (prefixLength !== 0) {
      tr.setSelection(TextSelection.create(tr.doc, start + match1Offset + match[1].length, start + match2Offset))
      tr.deleteSelection()
    }
    tr.setSelection(
      TextSelection.create(tr.doc, start + match2Offset + match[2].length - prefixLength, end - prefixLength),
    )
    tr.deleteSelection()
    if (match[0].endsWith(' ') && !match[2].endsWith(' ')) {
      tr.insertText(' ', start + match[1].length + match[2].length)
    }
    tr.removeStoredMark(mark)
    return tr
  })
}

/// A set of input rules for creating the basic block quotes, lists,
/// code blocks, and heading.
export const buildInputRules = (schema: Schema) => {
  const rules = [orderedListRule(schema.nodes.ordered_list), bulletListRule(schema.nodes.bullet_list), codeMarkRule()]
  return inputRules({ rules })
}
